import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { DIAS_SEMANA, isEditable } from "../utils/tramite";
import "./css/components.css";
import { isInvalid } from "../utils/forms";
import { useTramite } from "../context/Tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import NumberField from "./controls/NumberField";
import Col from "./layout/Col";
import ArrayField from "./controls/ArrayField";
import { JornadaLaboralForm } from "./JornadaLaboralForm";
import { JornadaLaboralList } from "./JornadaLaboralList";

function crearJornadaLaboral(regimenLaboral) {
  return {
    diaSemana: DIAS_SEMANA.filter(
      (dia) =>
        regimenLaboral.map((jornada) => jornada.diaSemana).indexOf(dia) < 0,
    )[0],
    inicio: "",
    termino: "",
    turnos: "",
  };
}

function filtrarDiasSemana(diasSemana, jornadasLaborales) {
  return [
    ...DIAS_SEMANA.filter(
      (diaSemana) =>
        jornadasLaborales
          .map((jornadaLaboral) => jornadaLaboral.diaSemana)
          .indexOf(diaSemana) < 0,
    ),
  ];
}

export default function RegimenLaboralForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const handlePersonalChange = (event) => tramiteForm.handleChange(event);
  const handleRegimenLaboralChange = (event) => tramiteForm.handleChange(event);
  return (
    <Loader loadgin={false}>
      <Grid>
        <Row>
          <Col lg={3}>
            <NumberField
              id="personal"
              name="personal"
              label={t("tramite.personal")}
              value={tramiteForm.values.personal}
              onChange={handlePersonalChange}
              labelStyle={{ whiteSpace: "nowrap" }}
              isInvalid={isInvalid("personal", tramiteForm)}
              error={t(tramiteForm.errors.personal)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ArrayField
              id="regimenLaboral"
              name="regimenLaboral"
              label={t("tramite.regimenLaboral")}
              value={tramiteForm.values?.regimenLaboral}
              onChange={handleRegimenLaboralChange}
              createItem={crearJornadaLaboral}
              isInvalid={isInvalid("regimenLaboral", tramiteForm)}
              error={t(tramiteForm.errors.regimenLaboral)}
              disabled={!isEditable(tramite)}
            >
              {({
                value: regimenLaboral,
                append,
                remove,
                replace,
                select,
                selectedItem,
                selectedIndex,
                disabled,
              }) => (
                <Grid>
                  <Row>
                    <Col>
                      <JornadaLaboralForm
                        value={selectedItem}
                        page={selectedIndex}
                        pages={regimenLaboral.length}
                        select={select}
                        append={append}
                        replace={replace}
                        remove={remove}
                        diasSemana={filtrarDiasSemana(
                          DIAS_SEMANA,
                          regimenLaboral,
                        )}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <JornadaLaboralList
                        value={regimenLaboral}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
